import { SwimlaneViewModel } from './types';

export const isEmptyView = (viewModel: SwimlaneViewModel) => {
  const { groups, nodes, edges, rows } = viewModel;

  return ![groups, nodes, edges, rows].some(
    ({ add, update }) => add.length || update.length
  );
};
